import { useEffect } from "react";
import { _ContractFiles } from "../../../../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../../../../core/services/dataBean/useDataBean";
import { FileService } from "../../../../../../../../../core/services/FileService";
import usePaginator from "../../../../../../../../../modules/theme/Component/usePaginator";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../../../../../modules/theme/Component/PrintJson";
import { hr } from "date-fns/locale";

interface Props {
    IDAdquisitionContract?: number;
    IDAdquisitionItem?: number;
}

export const MyExpedientContractFiles = ({ IDAdquisitionItem }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ContractFiles);
    const paginador = usePaginator();
    const fileService = new FileService();


    useEffect(() => {
        if (IDAdquisitionItem) {
            getLista();
        }
    }, [IDAdquisitionItem])

    const getLista = () => {



        instance.getExpedientFilesRender(null, null, { 'IDAdquisitionItem': IDAdquisitionItem, 'State': 1 }).then(
            (resp: any) => {
                if (resp.List) {

                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    let tmp = resp.List;
                    tmp.forEach((element: any) => {
                        element.DataBeanProperties.trdRender = element.DataBeanProperties.TRDCode ? `${element.DataBeanProperties.TRDCode} - ${element.DataBeanProperties.TRDName}` : "N/P";
                        element.DataBeanProperties.itemRender = `${element.DataBeanProperties.IDAdquisitionItem} - ${element.DataBeanProperties.ItemDescription}`;
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>${element.DataBeanProperties.FileName}</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);

                } else {
                    setLista([]);
                }

            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <div className="row">
            {Array.isArray(lista) && lista.length > 0 ?
                (lista.map((data, index: number) => {
                    const expediente = data.DataBeanProperties;
                    return (
                        <div className="col-md-12" key={expediente.IDContractFiles}>
                            {(index < lista.length - 1 || lista.length === 1) && <hr />}
                            <p><strong>Etapa:</strong> {expediente.Etapa}</p>
                            <p><strong>{expediente.TemplateName}:</strong>{expediente.MediaContext ? <a href={fileService.getUrlFile(expediente.MediaContext, expediente.Media)} target='_blank'> {expediente.FileName}</a> : "Sin Documento"}</p>
                        </div>

                    )
                }))
                :
                <div className="col-md-12">
                    <div className="text-center p-5 bg-light rounded-3">
                        <i className="ri-search-eye-line display-4 text-muted"></i>
                        <p className="mt-2">Sin Datos del Expediente</p>
                    </div>
                </div>
            }
        </div>
    )
}